var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-row',[_c('a-col',{attrs:{"sm":{ span: 24 },"md":{ span: 24 },"xl":{ span: 20, offset: 2 }}},[_c('div',{staticClass:"card-container"},[_c('a-tabs',{attrs:{"type":"card"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"List of gene inhibitors"}},[_c('druglist')],1)],1)],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }